module.exports = __webpack_public_path__ + "static/media/Rosso.8c7e92af.png";